export default __webpack_public_path__ + "static/media/ic_mint.3ec6546c.svg";